module.exports = __webpack_public_path__ + "img/banner.c6c2cc9.png";